import { export_json_to_excel } from "../utils/excal/Export2Excel.js";
// export const proApiUrl = 'https://100.api.fxzb.vip';
export const proApiUrl = 'https://dev.100.api.fxzb.vip';
// export const proApiUrl = 'http://192.168.110.201:8201';
// export const proApiUrl = 'http://192.168.110.48:8102';
export const robNum = 0
export const unmannedNum = 0
export const lockingNum = 0
export const discount = 9300
export const merNo = 'UMS330105534771'    //线上东哥的银联账户号
//京东商家id
// 线上
// export const JdKeeperId = 'ff8080818c170b3d018c3ae778285f91'
// dev环境
export const JdKeeperId = 'ff8080818bd8d452018bd92cc9470027'
// 本地环境
// export const JdKeeperId = '2c9082718be19cab018be1e95dd50042'

export function mahuaNoticeStatus(status) {
    let backData = {
        text: '待支付',
    }
    switch (status) {
        case "1":
            backData.text = '已出餐';
            break;
        case "3":
            backData.text = '取餐码';
            break;
        case "4":
            backData.text = '已接单';
            break;
        case "5":
            backData.text = '配送中';
            break;
        case "7":
            backData.text = '已完成';
            break;
        default:
            backData.text = '退单';
    }
}
export function currentUrlToParams(key = null) {
    let paramsUrl = (window.location.href).split('?');
    if (paramsUrl.length < 2) return key ? null : {};
    let paramsArr = paramsUrl[1].split('&');
    let paramsData = {}
    paramsArr.forEach(r => {
        let data = r.split('=')
        paramsData[data[0]] = data[1]
    })
    if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null;
    return paramsData;
}

export function clone(obj) {
    let strData = JSON.stringify(obj)
    return JSON.parse(strData);
}

export function toRate(rate) {
    let data = parseFloat(rate);
    return ((data >= 1 ? data : data * 10).toString().replace('.', '') + '0000').substring(0, 4)
}

export function toRateString(rate) {
    return (rate / 1000).toFixed(2);
}

export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.ceil(n * k) / k;
        };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

//时间戳转换方法    date:时间戳数字
export function format_ymd(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD;
}
// 时间戳转换方法    date:时间戳数字
export function format_date_ymd(date) {
    var date = new Date(date)
    var YY = date.getFullYear() + '-'
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    return YY + MM + DD
}

//时间戳转换方法    date:时间戳数字
export function format_datestr(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD + " " + hh + mm;


}


//时间戳转换方法    date:时间戳数字
export function format_hm(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return hh + mm;
}


//时间戳转换方法    date:时间戳数字
export function format_datestrss(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';;
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return MM + DD + " " + hh + mm + ss;
}
//时间戳转换方法    date:时间戳数字
export function format_yrsf(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    // + ss
    return MM + DD + " " + hh + mm
}

// 计算两个时间差 dateBegin 开始时间
export function timeFn(dateBegin) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date();//获取当前时间
    var dateDiff = dateBegin - dateEnd.getTime();//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}

// 计算两个时间差 dateBegin 开始时间
export function timetwo(dateend) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date();//获取当前时间
    var dateDiff = dateEnd.getTime() - dateend;//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}
//计算出票等待时间
export function timewait(completedTime, takeTime) {
    var dateDiff = completedTime - takeTime;//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}

// 计算两个时间差 dateBegin 开始时间
export function time_cz(start_time, end_time) {
    var dateDiff = end_time - start_time;//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)

    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分 "

    // seconds = seconds == 0 ? '' : seconds+"秒 "
    // minseconds = minseconds = 0 ? '': minseconds+'毫秒'

    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";

    if (timeFn.length == 0) {
        timeFn = '0分'
    }
    console.log('timeFn', timeFn)
    return timeFn;
}

/** 导出Excel */
export function explor_excel(header, filterData, excelData, name) {
    require.ensure([], () => {
        // that.excelData为传入的数据
        const data = formatJson(filterData, excelData);
        export_json_to_excel(header, data, name); // 导出的表格名称，根据需要自己命名
    });
}
function formatJson(filterVal, jsonData) {
    return jsonData.map((v) => filterVal.map((j) => v[j]));
}

// 随机数字
export function randomNo(length) {
    var str = '0123456789';
    var result = '';
    for (var i = length; i > 0; --i) {
        result += str[Math.floor(Math.random() * str.length)];
    }
    return result;
}


// 处理精度问题
export function signFigures(num, rank = 6) {
    if (!num) return (0);
    const sign = num / Math.abs(num);
    const number = num * sign;
    const temp = rank - 1 - Math.floor(Math.log10(number));
    let ans;
    if (temp > 0) {
        ans = parseFloat(number.toFixed(temp));
    }
    else if (temp < 0) {
        ans = Math.round(number / Math.pow(10, temp)) * temp;
    }
    else {
        ans = Math.round(number);
    }
    return (ans * sign);
}

// 处理影票规则数据
export function handlerMovieRuleData(settingData, id) {
    let settingList = settingData.map((item, index) => {
        return {
            // 城市、影院、影厅、电影、院线 设置为对象
            mianSetting: JSON.stringify({
                // 城市
                cityCode: item.cityCode,
                excludeCityCode: item.excludeCityCode,
                cityName: item.cityName,
                excludeCityName: item.excludeCityName,

                cityNameArr: item.cityName ? item.cityName.split(',') : [],
                excludeCityNameArr: item.excludeCityName ? item.excludeCityName.split(',') : [],
                cityCodeArr: item.cityName ? item.cityCode.split(',') : [],
                excludeCityCodeArr: item.excludeCityCode ? item.excludeCityCode.split(',') : [],

                // 院线
                cinemaLineId: item.cinemaLineId,
                excludeCinemaLineId: item.excludeCinemaLineId,
                cinemaLineName: item.cinemaLineName,
                excludeCinemaLineName: item.excludeCinemaLineName,
                cinemaLineIdArr: item.cinemaLineId ? item.cinemaLineId.split(',') : [],
                excludeCinemaLineIdArr: item.excludeCinemaLineId ? item.excludeCinemaLineId.split(',') : [],

                // 影院
                cinemaKeyword: item.cinemaKeyword,
                excludeCinemaKeyword: item.excludeCinemaKeyword,
                cinemaKeywordArr: item.cinemaKeyword ? item.cinemaKeyword.split(',') : [],
                excludeCinemaKeywordArr: item.excludeCinemaKeyword ? item.excludeCinemaKeyword.split(',') : [],

                // 电影
                movieKeyword: item.movieKeyword,
                excludeMovieKeyword: item.excludeMovieKeyword,
                movieKeywordArr: item.movieKeyword ? item.movieKeyword.split(',') : [],
                excludeMovieKeywordArr: item.excludeMovieKeyword ? item.excludeMovieKeyword.split(',') : [],

                // 影厅
                hallKeyword: item.hallKeyword,
                excludeHallKeyword: item.excludeHallKeyword,
                hallKeywordArr: item.hallKeyword ? item.hallKeyword.split(',') : [],
                excludeHallKeywordArr: item.excludeHallKeyword ? item.excludeHallKeyword.split(',') : [],

                // showCity: false,
                // showBrand: false,
                // showShop: false,
                showCity: false,
                showLine: false,
                showCinema: false,
                showMovie: false,
                showHall: false,
            }),
            // 价格区间
            maxOriginPrice: item.maxOriginPrice,
            minOriginPrice: item.minOriginPrice,
            //  id
            id: item.id,
            // 排序
            priceIndex: item.priceIndex,
            // 接单价
            bidTakePrice: item.bidTakePrice,
            // 销售价
            channelSalePrice: item.channelSalePrice,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    maxOriginPrice: set.maxOriginPrice,
                    minOriginPrice: set.minOriginPrice,
                    // 接单价
                    bidTakePrice: set.bidTakePrice,
                    minBidTakeDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.bidTakePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxBidTakeDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.bidTakePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    // 销售价
                    channelSalePrice: set.channelSalePrice,
                    minSaleDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.channelSalePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxSaleDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.channelSalePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    //  id
                    id: set.id,
                    // 排序
                    priceIndex: set.priceIndex,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            otherSettingData: otherSettingData,
        };
    })
    console.log(mianSettings)
    return mianSettings;
}


// 分解得到提交的数据
export function decomposeMovieRuleData(cities, lines, mianSettings) {

    let sub_movie_rule_data = [];
    mianSettings.map(set => {
        // 循环价格的数据
        set.otherSettingData.forEach(other_set => {
            sub_movie_rule_data.push({
                // 城市
                cityName: set.mianSetting.cityNameArr.length > 0 ? set.mianSetting.cityNameArr.toString() : '',
                excludeCityName: set.mianSetting.excludeCityNameArr.length > 0 ? set.mianSetting.excludeCityNameArr.toString() : '',

                cityCode: getCityCodeString(cities, set.mianSetting.cityNameArr),
                excludeCityCode: getCityNameString(cities, set.mianSetting.excludeCityNameArr),

                // 院线
                cinemaLineId: set.mianSetting.cinemaLineIdArr.length > 0 ? set.mianSetting.cinemaLineIdArr.toString() : '',
                excludeCinemaLineId: set.mianSetting.excludeCinemaLineIdArr.length > 0 ? set.mianSetting.excludeCinemaLineIdArr.toString() : '',
                cinemaLineName: getLineNameString(lines, set.mianSetting.cinemaLineIdArr),
                excludeCinemaLineName: getLineNameString(lines, set.mianSetting.excludeCinemaLineIdArr),

                // 影院
                cinemaKeyword: set.mianSetting.cinemaKeywordArr.length > 0 ? set.mianSetting.cinemaKeywordArr.toString() : '',
                excludeCinemaKeyword: set.mianSetting.excludeCinemaKeywordArr.length > 0 ? set.mianSetting.excludeCinemaKeywordArr.toString() : '',

                // 电影
                movieKeyword: set.mianSetting.movieKeywordArr.length > 0 ? set.mianSetting.movieKeywordArr.toString() : '',
                excludeMovieKeyword: set.mianSetting.excludeMovieKeyword.length > 0 ? set.mianSetting.excludeMovieKeyword.toString() : '',

                // 影厅
                hallKeyword: set.mianSetting.hallKeywordArr.length > 0 ? set.mianSetting.hallKeywordArr.toString() : '',
                excludeHallKeyword: set.mianSetting.excludeHallKeywordArr.length > 0 ? set.mianSetting.excludeHallKeywordArr.toString() : '',

                // 价格区间
                maxOriginPrice: other_set.maxOriginPrice,
                minOriginPrice: other_set.minOriginPrice,
                // 接单价
                bidTakePrice: other_set.bidTakePrice,
                // 销售价
                channelSalePrice: other_set.channelSalePrice,
                //  id
                id: other_set.id,
                // 排序
                priceIndex: other_set.priceIndex,
            })
        })
    })
    return sub_movie_rule_data;
}

//处理本地生活规则数据
export function localItemsData(list, typeList) {
    let settingList = list.map((item, index) => {
        return {
            mianSetting: JSON.stringify({
                //商品类型
                goodsCategoryIds: item.goodsCategoryIds ? item.goodsCategoryIds : [],
                //门店类型
                includeSubCategoryCodes: item.includeSubCategoryCodes ? item.includeSubCategoryCodes : [],
                excludeSubCategoryCodes: item.excludeSubCategoryCodes ? item.excludeSubCategoryCodes : [],
                includeSubCategoryNames: item.includeSubCategoryNames ? item.includeSubCategoryNames : [],
                excludeSubCategoryNames: item.excludeSubCategoryNames ? item.excludeSubCategoryNames : [],
                //商家
                includeShopKeeperIds: item.includeShopKeeperIds ? item.includeShopKeeperIds : [],
                excludeShopKeeperIds: item.excludeShopKeeperIds ? item.excludeShopKeeperIds : [],
                includeShopKeeperNames: item.includeShopKeeperNames ? item.includeShopKeeperNames : [],
                excludeShopKeeperNames: item.excludeShopKeeperNames ? item.excludeShopKeeperNames : [],
                //门店
                includeShopIds: item.includeShopIds ? item.includeShopIds : [],
                excludeShopIds: item.excludeShopIds ? item.excludeShopIds : [],
                includeShopNames: item.includeShopNames ? item.includeShopNames : [],
                excludeShopNames: item.excludeShopNames ? item.excludeShopNames : [],
                //商品
                includeGoodsIds: item.includeGoodsIds ? item.includeGoodsIds : [],
                includeGoodsNames: item.includeGoodsNames ? item.includeGoodsNames : [],
                excludeGoodsIds: item.excludeGoodsIds ? item.excludeGoodsIds : [],
                excludeGoodsNames: item.excludeGoodsNames ? item.excludeGoodsNames : [],
                //套餐
                includeGoodsItemIds: item.includeGoodsItemIds ? item.includeGoodsItemIds : [],
                includeGoodsItemNames: item.includeGoodsItemNames ? item.includeGoodsItemNames : [],
                excludeGoodsItemIds: item.excludeGoodsItemIds ? item.excludeGoodsItemIds : [],
                excludeGoodsItemNames: item.excludeGoodsItemNames ? item.excludeGoodsItemNames : [],
            }),
            // 利润价格区间
            minProfitAmount: item.minProfitAmount / 100,
            maxProfitAmount: item.maxProfitAmount / 100,
            //  id
            id: item.id,
            // 结算价
            settleAmount: item.settleAmount / 100,
            // 销售价
            saleAmount: item.saleAmount / 100,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    minProfitAmount: set.minProfitAmount,
                    maxProfitAmount: set.maxProfitAmount,
                    // 结算价
                    settleAmount: set.settleAmount,
                    // 销售价
                    saleAmount: set.saleAmount,
                    //  id
                    id: set.id,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            items: otherSettingData,
        };
    })
    let lists = []
    let shopKeeperList = []
    let shopKeeperLists = []
    let storeList = []
    let storeLists = []
    let goodsList = []
    let goodsLists = []
    let packageList = []
    let packageLists = []
    let goodsCategoryNames = []
    let goodsTypeList = [
        { name: "福袋", value: "BlindBox", desc: '福袋随机商品', disabled: false },
        { name: "团购", value: "CheckCode", desc: '支持线下核销、到店自提', disabled: false },
        { name: "优惠劵", value: "OfflineCoupon", desc: '线下核销优惠劵、到店自提', disabled: false },
        { name: "电商", value: "Goods", desc: '快递邮寄、同城配送', disabled: false },
        { name: "卡劵", value: "ECard", desc: '通过卡号卡密核销', disabled: false },
        { name: "视频", value: "LearnVideo", desc: '在线视频学习', disabled: false },
        { name: "外卖", value: "TakeoutGoods", desc: '外送到家', disabled: false },
    ]
    let includeSubCategoryNames = []
    let excludeSubCategoryNames = []
    mianSettings.map(item => {
        console.log(item.mianSetting.includeSubCategoryCodes, 'item.mianSetting.includeSubCategoryIds')
        if (item.mianSetting.goodsCategoryIds) {
            goodsCategoryNames = []
            item.mianSetting.goodsCategoryIds.map((i, inx) => {
                goodsTypeList.map(type => {
                    if (i == type.value) {
                        goodsCategoryNames.push(type.name)
                    }
                })
            })
        }
        if (item.mianSetting.includeSubCategoryCodes) {
            includeSubCategoryNames = []
            item.mianSetting.includeSubCategoryCodes.map((i, inx) => {
                typeList.map(type => {
                    if (i == type.code) {
                        includeSubCategoryNames.push(type.name)
                    }
                })
            })
        }
        if (item.mianSetting.excludeSubCategoryCodes) {
            excludeSubCategoryNames = []
            item.mianSetting.excludeSubCategoryCodes.map((i, inx) => {
                typeList.map(type => {
                    if (i == type.code) {
                        excludeSubCategoryNames.push(type.name)
                    }
                })
            })
        }
        if (item.mianSetting.includeShopKeeperIds) {
            item.mianSetting.includeShopKeeperIds.map((i, inx) => {
                shopKeeperList.push({
                    shopName: item.mianSetting.includeShopKeeperNames[inx],
                    shopKeeperId: i
                })
            })
        }
        console.log(shopKeeperList, 'shopKeeperList')
        if (item.mianSetting.excludeShopKeeperIds) {
            item.mianSetting.excludeShopKeeperIds.map((i, inx) => {
                shopKeeperLists.push({
                    shopName: item.mianSetting.excludeShopKeeperNames[inx],
                    shopKeeperId: i
                })
            })
        }
        if (item.mianSetting.includeShopIds) {
            item.mianSetting.includeShopIds.map((i, inx) => {
                storeList.push({
                    name: item.mianSetting.includeShopNames[inx],
                    shopId: i
                })
            })
        }
        if (item.mianSetting.excludeShopIds) {
            item.mianSetting.excludeShopIds.map((i, inx) => {
                storeLists.push({
                    name: item.mianSetting.excludeShopNames[inx],
                    shopId: i
                })
            })
        }
        if (item.mianSetting.includeGoodsIds) {
            item.mianSetting.includeGoodsIds.map((i, inx) => {
                goodsList.push({
                    goodsName: item.mianSetting.includeGoodsNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.excludeGoodsIds) {
            item.mianSetting.excludeGoodsIds.map((i, inx) => {
                goodsLists.push({
                    goodsName: item.mianSetting.excludeGoodsNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.includeGoodsItemIds) {
            item.mianSetting.includeGoodsItemIds.map((i, inx) => {
                packageList.push({
                    subTitle: item.mianSetting.includeGoodsItemNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.excludeGoodsItemIds) {
            item.mianSetting.excludeGoodsItemIds.map((i, inx) => {
                packageLists.push({
                    subTitle: item.mianSetting.excludeGoodsItemNames[inx],
                    id: i
                })
            })
        }
        lists.push({
            //商品类型
            goodsCategoryIds: item.mianSetting.goodsCategoryIds ? item.mianSetting.goodsCategoryIds : [],
            goodsCategoryNames: goodsCategoryNames,
            //门店类型
            includeSubCategoryCodes: item.mianSetting.includeSubCategoryCodes ? item.mianSetting.includeSubCategoryCodes : [],
            excludeSubCategoryCodes: item.mianSetting.excludeSubCategoryCodes ? item.mianSetting.excludeSubCategoryCodes : [],
            includeSubCategoryNames: includeSubCategoryNames,
            excludeSubCategoryNames: excludeSubCategoryNames,
            //商家
            includeShopKeeperIds: item.mianSetting.includeShopKeeperIds ? item.mianSetting.includeShopKeeperIds : [],
            excludeShopKeeperIds: item.mianSetting.excludeShopKeeperIds ? item.mianSetting.excludeShopKeeperIds : [],
            includeShopKeeperNames: item.mianSetting.includeShopKeeperNames ? item.mianSetting.includeShopKeeperNames : [],
            excludeShopKeeperNames: item.mianSetting.excludeShopKeeperNames ? item.mianSetting.excludeShopKeeperNames : [],
            //门店
            includeShopIds: item.mianSetting.includeShopIds ? item.mianSetting.includeShopIds : [],
            excludeShopIds: item.mianSetting.excludeShopIds ? item.mianSetting.excludeShopIds : [],
            includeShopNames: item.mianSetting.includeShopNames ? item.mianSetting.includeShopNames : [],
            excludeShopNames: item.mianSetting.excludeShopNames ? item.mianSetting.excludeShopNames : [],
            //商品
            includeGoodsIds: item.mianSetting.includeGoodsIds ? item.mianSetting.includeGoodsIds : [],
            includeGoodsNames: item.mianSetting.includeGoodsNames ? item.mianSetting.includeGoodsNames : [],
            excludeGoodsIds: item.mianSetting.excludeGoodsIds ? item.mianSetting.excludeGoodsIds : [],
            excludeGoodsNames: item.mianSetting.excludeGoodsNames ? item.mianSetting.excludeGoodsNames : [],
            //套餐
            includeGoodsItemIds: item.mianSetting.includeGoodsItemIds ? item.mianSetting.includeGoodsItemIds : [],
            includeGoodsItemNames: item.mianSetting.includeGoodsItemNames ? item.mianSetting.includeGoodsItemNames : [],
            excludeGoodsItemIds: item.mianSetting.excludeGoodsItemIds ? item.mianSetting.excludeGoodsItemIds : [],
            excludeGoodsItemNames: item.mianSetting.excludeGoodsItemNames ? item.mianSetting.excludeGoodsItemNames : [],
            shopKeeperList: shopKeeperList,//包含商家列表
            shopKeeperLists: shopKeeperLists,//不包含商家列表
            storeList: storeList,//包含门店列表
            storeLists: storeLists,//不包含门店列表
            goodsList: goodsList,//包含商品列表
            goodsLists: goodsLists,//不包含商品列表
            packageList: packageList,//包含商品对应的套餐列表
            packageLists: packageLists,//不包含商品对应的套餐列表
            items: item.items,
            showSplx: false,
            showMdlx: false,
            showSj: false,
            showSp: false,
            showTc: false,
        })
    })
    return lists;
}

//处理蛋糕规则数据
export function cakeItemsData(list) {
    let settingList = list.map((item, index) => {
        return {
            mianSetting: JSON.stringify({
                //品牌
                includeBrandIds: item.includeBrandIds ? item.includeBrandIds : [],
                includeBrandNames: item.includeBrandNames ? item.includeBrandNames : [],
                excludeBrandIds: item.excludeBrandIds ? item.excludeBrandIds : [],
                excludeBrandNames: item.excludeBrandNames ? item.excludeBrandNames : [],
                //商品
                includeCakeGoodsIds: item.includeCakeGoodsIds ? item.includeCakeGoodsIds : [],
                includeCakeGoodsNames: item.includeCakeGoodsNames ? item.includeCakeGoodsNames : [],
                excludeCakeGoodsIds: item.excludeCakeGoodsIds ? item.excludeCakeGoodsIds : [],
                excludeCakeGoodsNames: item.excludeCakeGoodsNames ? item.excludeCakeGoodsNames : [],
                //套餐
                includeCakeGoodsItemIds: item.includeCakeGoodsItemIds ? item.includeCakeGoodsItemIds : [],
                includeCakeGoodsItemNames: item.includeCakeGoodsItemNames ? item.includeCakeGoodsItemNames : [],
                excludeCakeGoodsItemIds: item.excludeCakeGoodsItemIds ? item.excludeCakeGoodsItemIds : [],
                excludeCakeGoodsItemNames: item.excludeCakeGoodsItemNames ? item.excludeCakeGoodsItemNames : [],
            }),
            // 利润价格区间
            minPrice: item.minPrice / 100,
            maxPrice: item.maxPrice / 100,
            //  id
            id: item.id,
            tmplId: item.tmplId,
            // 结算价
            floatSettlePrice: item.floatSettlePrice / 100,
            // 销售价
            floatSalePrice: item.floatSalePrice / 100,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    minPrice: set.minPrice,
                    maxPrice: set.maxPrice,
                    // 结算价
                    floatSettlePrice: set.floatSettlePrice,
                    // 销售价
                    floatSalePrice: set.floatSalePrice,
                    //  id
                    id: set.id,
                    tmplId: set.tmplId,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            items: otherSettingData,
        };
    })
    let lists = []
    let goodsList = []
    let goodsLists = []
    let packageList = []
    let packageLists = []
    let brandList = []
    let brandLists = []
    mianSettings.map(item => {
        if (item.mianSetting.includeBrandIds) {
            item.mianSetting.includeBrandIds.map((i, inx) => {
                brandList.push({
                    name: item.mianSetting.includeBrandNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.excludeBrandIds) {
            item.mianSetting.excludeBrandIds.map((i, inx) => {
                brandLists.push({
                    name: item.mianSetting.excludeBrandNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.includeCakeGoodsIds) {
            item.mianSetting.includeCakeGoodsIds.map((i, inx) => {
                goodsList.push({
                    name: item.mianSetting.includeCakeGoodsNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.excludeCakeGoodsIds) {
            item.mianSetting.excludeCakeGoodsIds.map((i, inx) => {
                goodsLists.push({
                    name: item.mianSetting.excludeCakeGoodsNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.includeCakeGoodsItemIds) {
            item.mianSetting.includeCakeGoodsItemIds.map((i, inx) => {
                packageList.push({
                    name: item.mianSetting.includeCakeGoodsItemNames[inx],
                    id: i
                })
            })
        }
        if (item.mianSetting.excludeCakeGoodsItemIds) {
            item.mianSetting.excludeCakeGoodsItemIds.map((i, inx) => {
                packageLists.push({
                    name: item.mianSetting.excludeCakeGoodsItemNames[inx],
                    id: i
                })
            })
        }
        lists.push({
            //品牌
            includeBrandIds: item.mianSetting.includeBrandIds ? item.mianSetting.includeBrandIds : [],
            includeBrandNames: item.mianSetting.includeBrandNames ? item.mianSetting.includeBrandNames : [],
            excludeBrandIds: item.mianSetting.excludeBrandIds ? item.mianSetting.excludeBrandIds : [],
            excludeBrandNames: item.mianSetting.excludeBrandNames ? item.mianSetting.excludeBrandNames : [],
            //商品
            includeCakeGoodsIds: item.mianSetting.includeCakeGoodsIds ? item.mianSetting.includeCakeGoodsIds : [],
            includeCakeGoodsNames: item.mianSetting.includeCakeGoodsNames ? item.mianSetting.includeCakeGoodsNames : [],
            excludeCakeGoodsIds: item.mianSetting.excludeCakeGoodsIds ? item.mianSetting.excludeCakeGoodsIds : [],
            excludeCakeGoodsNames: item.mianSetting.excludeCakeGoodsNames ? item.mianSetting.excludeCakeGoodsNames : [],
            //套餐
            includeCakeGoodsItemIds: item.mianSetting.includeCakeGoodsItemIds ? item.mianSetting.includeCakeGoodsItemIds : [],
            includeCakeGoodsItemNames: item.mianSetting.includeCakeGoodsItemNames ? item.mianSetting.includeCakeGoodsItemNames : [],
            excludeCakeGoodsItemIds: item.mianSetting.excludeCakeGoodsItemIds ? item.mianSetting.excludeCakeGoodsItemIds : [],
            excludeCakeGoodsItemNames: item.mianSetting.excludeCakeGoodsItemNames ? item.mianSetting.excludeCakeGoodsItemNames : [],

            brandList: brandList,//包含门店列表
            brandLists: brandLists,//不包含门店列表
            goodsList: goodsList,//包含商品列表
            goodsLists: goodsLists,//不包含商品列表
            packageList: packageList,//包含商品对应的套餐列表
            packageLists: packageLists,//不包含商品对应的套餐列表
            items: item.items,
            showSplx: false,
            showSp: false,
            showTc: false,
        })
    })
    return lists;
}

// 处理点餐规则数据【麻花】
export function handlerMahuaRuleData(settingData, id) {
    let settingList = settingData.map((item, index) => {
        return {
            // 城市、品牌、店铺、设置为对象
            mianSetting: JSON.stringify({
                // 城市
                cityCode: item.cityCodeList,
                excludeCityCode: item.excludeCityCodeList,
                cityName: item.cityNameList,
                excludeCityName: item.excludeCityNameList,

                cityNameArr: item.cityNameList ? item.cityNameList.split(',') : [],
                excludeCityNameArr: item.excludeCityNameList ? item.excludeCityNameList.split(',') : [],
                cityCodeArr: item.cityCodeList ? item.cityCodeList.split(',') : [],
                excludeCityCodeArr: item.excludeCityCodeList ? item.excludeCityCodeList.split(',') : [],

                // 品牌
                brandCodeList: item.brandCodeList,
                excludeBrandCodeList: item.excludeBrandCodeList,

                brandNameList: item.brandNameList,
                excludeBrandNameList: item.excludeBrandNameList,

                brandCodeListArr: item.brandCodeList ? item.brandCodeList.split(',') : [],
                excludeBrandCodeListArr: item.excludeBrandCodeList ? item.excludeBrandCodeList.split(',') : [],

                // 店铺
                shopIdList: item.shopIdList,
                shopNameList: item.shopNameList,
                excludeShopIdList: item.excludeShopIdList,
                excludeShopNameList: item.excludeShopNameList,
                shopIdListArr: item.shopIdList ? item.shopIdList.split(',') : [],
                excludeShopIdListArr: item.excludeShopIdList ? item.excludeShopIdList.split(',') : [],

                showCity: false,
                showBrand: false,
                showShop: false,
            }),
            // 利润价格区间
            minProfitAmount: item.minProfitAmount / 100,
            maxProfitAmount: item.maxProfitAmount / 100,
            //  id
            id: item.id,
            // 结算价
            settlePrice: item.settlePrice / 100,
            // 销售价
            salePrice: item.salePrice / 100,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    minProfitAmount: set.minProfitAmount,
                    maxProfitAmount: set.maxProfitAmount,
                    // 结算价
                    settlePrice: set.settlePrice,
                    // 销售价
                    salePrice: set.salePrice,
                    //  id
                    id: set.id,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            otherSettingData: otherSettingData,
        };
    })
    console.log('mianSettings', mianSettings)
    return mianSettings;
}

// 分解得到提交的数据[麻花点餐模板]
export function decomposeMahuaRuleData(cities, brands, mianSettings) {
    let sub_movie_rule_data = [];

    console.log('mianSettings', mianSettings)

    mianSettings.map(set => {
        // 循环价格的数据
        set.otherSettingData.forEach(other_set => {
            sub_movie_rule_data.push({
                // 城市
                cityName: set.mianSetting.cityNameArr.length > 0 ? set.mianSetting.cityNameArr.toString() : '',
                excludeCityName: set.mianSetting.excludeCityNameArr.length > 0 ? set.mianSetting.excludeCityNameArr.toString() : '',
                cityCode: getCityCodeString(cities, set.mianSetting.cityNameArr),
                excludeCityCode: getCityCodeString(cities, set.mianSetting.excludeCityNameArr),
                // 品牌
                brandCodeList: set.mianSetting.brandCodeListArr.length > 0 ? set.mianSetting.brandCodeListArr.toString() : '',
                excludeBrandCodeList: set.mianSetting.excludeBrandCodeListArr.length > 0 ? set.mianSetting.excludeBrandCodeListArr.toString() : '',
                brandNameList: getBrandNameString(brands, set.mianSetting.brandCodeListArr),
                excludeBrandNameList: getBrandNameString(brands, set.mianSetting.excludeBrandCodeListArr),
                // 店铺
                shopIdList: getShopIdAndName(set.mianSetting.shopNameListArr).ids,
                shopNameList: getShopIdAndName(set.mianSetting.shopNameListArr).names,
                excludeShopIdList: getShopIdAndName(set.mianSetting.excludeShopNameListArr).ids,
                excludeShopNameList: getShopIdAndName(set.mianSetting.excludeShopNameListArr).names,

                // 价格区间
                maxProfitAmount: other_set.maxProfitAmount * 100,
                minProfitAmount: other_set.minProfitAmount * 100,
                // 结算价
                settlePrice: other_set.settlePrice * 100,
                // 销售价
                salePrice: other_set.salePrice * 100,
                //  id
                id: other_set.id,
            })
        })
    })
    return sub_movie_rule_data;
}


export function ruleCityName(cities, list) {
    let array = []
    list.map(item => {
        array.push({
            includeCityCodes: item.includeCityCodes,
            includeCityNames: getCityName(cities, item.includeCityCodes),
            costAmount: item.costAmount * 100,
            saleAmount: item.saleAmount * 100,
            settleAmount: item.settleAmount * 100,
            goodsId: item.goodsId,
            goodsItemId: item.goodsItemId,
            id: item.id ? item.id : null,
        })
    })
    return array
}
// 根据code 获取到 name
function getCityName(originalCityData, codes) {
    let names = [];
    codes.forEach(code => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityCode == code;
        });
        if (city) {
            names.push(city.cityName);
        }
    })
    return names
}
// 根据code 获取到 name
function getCityNameString(originalCityData, codes) {
    let names = [];
    codes.forEach(code => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityCode == code;
        });
        if (city) {
            names.push(city.cityName);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 根据code 获取到 name
function getCityCodeString(originalCityData, names) {
    let codes = [];
    names.forEach(name => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityName == name;
        });
        if (city) {
            codes.push(city.cityCode);
        }
    })
    return codes.length > 0 ? codes.toString() : '';
}

// [院线]根据id 获取到 name
function getLineNameString(lineData, ids) {
    let names = [];
    ids.forEach(id => {
        let line_obj = lineData.find(line => {
            return line.id == id;
        })
        if (line_obj) {
            names.push(line_obj.name);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 【品牌】根据id 获取到 name
function getBrandNameString(brands, ids) {
    let names = [];
    ids.forEach(id => {
        let brand = brands.find(line => {
            return line.id == id;
        })
        if (brand) {
            names.push(brand.name);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 【店铺】
function getShopIdAndName(idNameArr) {
    let backData = {
        ids: [],
        names: []
    };
    (idNameArr || []).forEach(id_name => {
        let id_names = id_name.split('ぁ');
        backData.ids.push(id_names[0]);
        backData.names.push(id_names[1]);
    })
    if (backData.ids.length == 0) {
        backData.ids = '';
    }
    if (backData.names.length == 0) {
        backData.names = '';
    }
    backData.ids = backData.ids.toString();
    backData.names = backData.names.toString();
    return backData;
}

// 正整数 > 0
export function check_num(num) {
    //js只能输入正整数（不包括负整数和0）
    if (!(/(^[1-9]\d*$)/.test(num))) {
        return false
    }
    return true
}


// 提取数字
export function match_number(str) {
    let num_arr = str.match(/\d+(.\d+)?/g);
    if (num_arr.length > 0) {
        return num_arr[0]
    }
    return ''
}
export function getNextDate(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "-" + m + "-" + d;
}
export function getAddrss(key, refer) {
    const TMap_URL = `https://apis.map.qq.com/tools/geolocation/min?key=${key}&referer=${refer}&callback=onLocationCallback`;
    return new Promise((resolve, reject) => {
        // 如果已加载直接返回
        if (typeof window.qq !== "undefined") {
            resolve(new window.qq.maps.Geolocation(key, refer));
            return true;
        }
        // 地图异步加载回调处理
        window.onLocationCallback = function () {
            resolve(new window.qq.maps.Geolocation(key, refer));
        };
        // 插入script脚本
        let scriptNode = document.createElement("script");
        scriptNode.setAttribute("type", "text/javascript");
        scriptNode.setAttribute("src", TMap_URL);
        document.body.appendChild(scriptNode);
    });
}

export function treeData(data, list) {
    for (let i of list) {
        let array = data.filter(item => {
            let code = new RegExp(i.code + "-([a-zA-Z0-9]+)$")
            return code.test(item.code);
        })
        if (array.length > 0) {
            i.children = array
            treeData(data, array)
        }
    }
    return list[0].children;
}
//去8个字母数字组合
export function random() {
    let str = ""
    let array = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
    ];
    for (let i = 0; i < 8; i++) {
        str +=
            array[Math.round(Math.random() * (array.length - 1))];
    }
    return str
}
//城市数据格式
export function cityData(list) {
    console.log(list, 'list')
    let cityList = []
    list.map(item => {
        if (item.level == 'province') {
            cityList.push({
                value: item.code,
                label: item.name,
                children: []
            })
        }
    })
    list.map(item => {
        // && (i.value.substring(0, 2) == item.code.substring(0, 2)) && (i.value != item.code)
        cityList.map(i => {
            if (item.level == 'city' && (i.value.substring(0, 2) == item.code.substring(0, 2))) {
                i.children.push({
                    value: item.code,
                    label: item.name,
                    num: item.num
                })
            }
        })
    })
    return cityList;
}
/**
   * 手机号中间四位为*
   */
export function InterceptPhone(phone) {
    return phone.substring(0, 3) + '****' + phone.substring(7)
}
/**将数组中具有相同值的对象 取出组成新的数组 */
export function sortArr(arr, str) {
    console.log(JSON.parse(JSON.stringify(arr)), str)
    let _arr = [],
        _t = [],
        // 临时的变量
        _tmp

    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort(function (a, b) {
        const s = a[str],
            t = b[str]
        return s < t ? -1 : 1
    })
    if (arr.length) {
        _tmp = arr[0][str]
    }
    for (const i in arr) {
        if (arr[i][str] === _tmp) {
            _t.push(arr[i])
        } else {
            _tmp = arr[i][str]
            _arr.push(_t)
            _t = [arr[i]]
        }
    }
    // 将最后的内容推出新数组
    _arr.push(_t)
    return _arr
}

// 获取院线名称数组
export function cinemaLineNamesById(cinemaLineData, lineIds) {
    let lineNames = [];
    lineIds.forEach(line_id => {
        let line = cinemaLineData.find(item => {
            return item.id == line_id
        });
        if (line) {
            lineNames.push(line.name)
        }
    });
    return lineNames;
}
// 字符串code 返回省市组件需要的 数据结构 [ [],[]]
export function backCodeArr(codeStr) {
    let back_code_arr = [];
    let code_arr = codeStr ? codeStr.split(',') : []
    code_arr.forEach(code => {
        // 省份
        if (code.indexOf('0000') > 1) {
            back_code_arr.push([code])
        } else {
            // 城市
            back_code_arr.push([code.substr(0, 2) + '0000', code])
        }
    })
    console.log('back_code_arr', back_code_arr)
    return back_code_arr;
}
//根据两个值计算折扣
export function getDiscount(price, prices) {
    return (price / prices * 10).toFixed(2)
}
//商品数据来源处理
export function originData(origin) {
    let text = ''
    if (origin == 'Lianlian') {
        text = '联'
    } else if (origin == 'LocalShop') {
        text = '自'
    } else if (origin == 'JdJwt') {
        text = '京东官方'
    } else if (origin == 'JdPlus') {
        text = '京东官方'
    }
    return text
}
// 获取几天后的时间
export function getDateAfter(time, n, takeTime) {// n为多少天，-代表往前，+代表往后
    let date1 = new Date(time)
    console.log(date1, 'date1')
    // let time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();//time1表示当前时间
    let date2 = new Date(date1);
    console.log(date2, 'date2')
    date2.setDate(date1.getDate() + (n - 1));
    let time2 = date2.getFullYear() + "-" + ("0" + (date2.getMonth() + 1)).slice(-2) + "-" + ("0" + date2.getDate()).slice(-2) + ' ' + takeTime;
    console.log(time2, 'time2')
    return new Date(time2).getTime()
}

/**
   * 颜色字符串解析为颜色对象
   * @param color 颜色字符串
   * @returns
   */
export const toHex = (n) => `${n > 15 ? '' : 0}${n.toString(16)}`;
export function parseColorString(color) {
    const arr = color.match(/(\d(\.\d+)?)+/g) || [];
    const res = arr.map((s) => parseInt(s, 10));
    return `#${toHex(res[0])}${toHex(res[1])}${toHex(res[2])}${res[3] === 1 ? '' : toHex(Math.floor(a * 255))}`
};
//获取字符串中的两个颜色值
export function getColor(obj) {
    let color1 = ''
    let color2 = ''
    if (obj) {
        const index1 = obj.indexOf('#')
        const index2 = obj.indexOf('#', index1 + 1)
        color1 = obj.substr(index1, 7)
        color2 = obj.substr(index2, 7)
    }
    return {
        color1,
        color2
    }
}
export function jdRuleData(list, id) {
    let myItems = []
    list.map(item => {
        let goodsList = []
        let items = []
        goodsList.push({
            goodsName: item.origin.includeGoodsNames.toString(),
            goodsId: item.origin.includeGoodsIds.toString()
        })
        if (id) {
            items.push({
                costAmount: Number((item.costAmount / 100).toFixed(2)),
                lockSettlePrice: item.lockSettlePrice,
                saleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
                settleAmount: Number((item.settleAmount / 100).toFixed(2)),
                subTitle: item.origin.includeGoodsItemNames.toString(),
                membershipCardFloat: Number((item.membershipCardFloat / 100).toFixed(2)),
                goodsItemId: item.origin.includeGoodsItemIds.toString(),
                originId: item.originId,
                contract: item.contract,
                beginTime: item.beginTime ? item.beginTime : '',
                endTime: item.endTime ? item.endTime : '',
                isSeckill: (item.beginTime || item.endTime) ? true:false,
            })
        } else {
            items.push({
                costAmount: Number((item.origin.settleAmount / 100).toFixed(2)),
                lockSettlePrice: false,
                saleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
                settleAmount: '',
                membershipCardFloat: Number((item.membershipCardFloat / 100).toFixed(2)),
                subTitle: item.origin.includeGoodsItemNames.toString(),
                goodsItemId: item.origin.includeGoodsItemIds.toString(),
                originId: item.originId,
                contract: item.contract,
                beginTime: item.beginTime ? item.beginTime : '',
                endTime: item.endTime ? item.endTime : '',
                isSeckill: (item.beginTime || item.endTime) ? true:false,
            })
        }
        myItems.push({
            goodsList,
            items,
        })
    })
    var mianSetObj = {}
    // 找出 mianSetting 中的重复对象
    let mianSettings = myItems.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.goodsList[0].goodsId]) {
            mianSetObj[next.goodsList[0].goodsId] = true
            cur.push(next.goodsList[0].goodsId)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur
    }, [])
    mianSettings = mianSettings.map(item => {
        let items1 = []
        let goodsList1 = []
        myItems.map((set) => {
            if (item == set.goodsList[0].goodsId) {
                goodsList1 = set.goodsList
                items1.push({
                    costAmount: set.items[0].costAmount,
                    lockSettlePrice: set.items[0].lockSettlePrice,
                    saleAmount: set.items[0].saleAmount,
                    settleAmount: set.items[0].settleAmount,
                    subTitle: set.items[0].subTitle,
                    originId: set.items[0].originId,
                    goodsItemId: set.items[0].goodsItemId,
                    contract: set.items[0].contract,
                    membershipCardFloat: set.items[0].membershipCardFloat,
                    beginTime: set.items[0].beginTime ? set.items[0].beginTime : '',
                    endTime: set.items[0].endTime ? set.items[0].endTime : '',
                    isSeckill: set.items[0].isSeckill,
                })
            }
        })
        return {
            goodsList: goodsList1,
            items: items1
        }
    })
    console.log(mianSettings, 'mianSettings')
    return mianSettings
}
export function jdQuotationRule(list) {
    let myItems = []
    list.map(item => {
        let goodsList = []
        let items = []
        goodsList.push({
            goodsName: item.goodsName,
            goodsId: item.goodsId,
            sortIndex: item.sortIndex?item.sortIndex:0,
        })
        items.push({
            // saleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
            originPrice: Number((item.originPrice / 100).toFixed(2)),
            settlePrice: Number((item.settlePrice / 100).toFixed(2)),
            maxBidPrice: Number((item.maxBidPrice / 100).toFixed(2)),
            goodsItemName: item.goodsItemName,
            goodsItemId: item.goodsItemId,
            goodsId: item.goodsId,
            goodsName: item.goodsName,
            id: item.id,
            includeCityCodes: item.includeCityCodes ? item.includeCityCodes.split(',') : [],
            includeCityNames: item.includeCityNames ? item.includeCityNames.split(',') : [],
            isSeckill: (item.includeCityCodes || item.includeCityNames) ? true:false,
            hidden:item.hidden?true:false,
        })
        myItems.push({
            goodsList,
            items,
        })
    })
    var mianSetObj = {}
    // 找出 mianSetting 中的重复对象
    let mianSettings = myItems.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.goodsList[0].goodsId]) {
            mianSetObj[next.goodsList[0].goodsId] = true
            cur.push(next.goodsList[0].goodsId)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur
    }, [])
    mianSettings = mianSettings.map(item => {
        let items1 = []
        let goodsList1 = []
        myItems.map((set) => {
            if (item == set.goodsList[0].goodsId) {
                goodsList1 = set.goodsList
                items1.push({
                    originPrice: set.items[0].originPrice,
                    settlePrice: set.items[0].settlePrice,
                    goodsItemName: set.items[0].goodsItemName,
                    goodsId: set.items[0].goodsId,
                    goodsName: set.items[0].goodsName,
                    id: set.items[0].id,
                    goodsItemId: set.items[0].goodsItemId,
                    maxBidPrice: set.items[0].maxBidPrice,
                    includeCityCodes: set.items[0].includeCityCodes,
                    includeCityNames: set.items[0].includeCityNames,
                    isSeckill: set.items[0].isSeckill,
                    hidden:set.items[0].hidden,
                })
            }
        })
        return {
            goodsList: goodsList1,
            items: items1
        }
    })
    return mianSettings
}

export function carRuleData(list, id) {
    let myItems = []
    list.map(item => {
        let goodsList = []
        let items = []
        let cityList = []
        if (id) {
            goodsList.push({
                goodsName: item.goods.goodsName,
                goodsId: item.goodsId
            })
            if(item.includeCityCodes && item.includeCityNames){
                item.includeCityCodes.split(',').map((c,c_inx) =>{
                    cityList.push({
                        cityName:item.includeCityNames.split(',')[c_inx],
                        cityCode:c,
                    })
                })
            }
            items.push({
                originPrice: Number((item.goods.originPrice / 100).toFixed(2)),
                settlePrice: Number((item.goods.settlePrice / 100).toFixed(2)),
                salePrice: Number((item.goods.salePrice / 100).toFixed(2)),
                goodsId: item.goodsId,
                salePriceFloat: item.salePriceFloat?Number((item.salePriceFloat / 100).toFixed(2)):0,
                settlePriceFloat: item.settlePriceFloat?Number((item.settlePriceFloat / 100).toFixed(2)):0,
                settlePriceRatio: item.settlePriceRatio?Number((item.settlePriceRatio / 100).toFixed(2)):0,
                id: item.id,
                isCity: item.includeCityCodes?true:false,
                cityList: cityList,
                includeCityCodes: item.includeCityCodes ?item.includeCityCodes.split(','):[],
            })
        } else {
            goodsList.push({
                goodsName: item.goodsName,
                goodsId: item.id
            })
            items.push({
                originPrice: Number((item.originPrice / 100).toFixed(2)),
                settlePrice: Number((item.settlePrice / 100).toFixed(2)),
                salePrice: Number((item.salePrice / 100).toFixed(2)),
                goodsId: item.id,
                salePriceFloat:'',
                settlePriceFloat:'',
                settlePriceRatio:'',
                isCity: false,
                id:'',
                cityList:[],
                includeCityCodes:[],
            })
        }
        myItems.push({
            goodsList,
            items,
        })
    })
    var mianSetObj = {}
    // 找出 mianSetting 中的重复对象
    let mianSettings = myItems.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.goodsList[0].goodsId]) {
            mianSetObj[next.goodsList[0].goodsId] = true
            cur.push(next.goodsList[0].goodsId)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur
    }, [])
    mianSettings = mianSettings.map(item => {
        let items1 = []
        let goodsList1 = []
        myItems.map((set) => {
            if (item == set.goodsList[0].goodsId) {
                goodsList1 = set.goodsList
                items1.push({
                    settlePrice: set.items[0].settlePrice,
                    salePrice: set.items[0].salePrice,
                    originPrice: set.items[0].originPrice,
                    salePriceFloat: set.items[0].salePriceFloat,
                    settlePriceFloat: set.items[0].settlePriceFloat,
                    settlePriceRatio: set.items[0].settlePriceRatio,
                    goodsId: set.items[0].goodsId,
                    id: set.items[0].id,
                    isCity: set.items[0].isCity,
                    cityList: set.items[0].cityList,
                    includeCityCodes: set.items[0].includeCityCodes,
                })
            }
        })
        return {
            goodsList: goodsList1,
            items: items1
        }
    })
    console.log(mianSettings, 'mianSettings')
    return mianSettings
}